import { PJAxios } from "@jaf/jaf-react-core"


export const flushCache = (dbTest,storage) => {

    
    var instances = []
    const instancesTest = [
        "https://onlineservices.test.polimi.it/editorfaq2/rest/chatbot"
       // "http://dev0071.resources.polimi.it/editorfaq2/rest/chatbot"
        ]
    const instancesProd = [
        "https://onlineservices.polimi.it/editorfaq2/rest/chatbot"
    ]

    if (dbTest) {
        instances = instancesTest
    }else{
        instances = instancesProd
    }

    instances.forEach((i) => {
        const instance = PJAxios({
            baseURL: i, 
            isExternal: true,
            profile: 1
          })
          
          try{
            instance.get('/flushCache',{headers : {
                'Content-Type' : 'application/x-www-form-urlencoded; charset=UTF-8'
            }}).then((res) => {
                //console.log(res)
            })
          }catch(e){
             //console.log(e)
          }
          
    })
    
}